import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"

const connectToHub = async(hubName: string) => {

  const apiUrl = process.env.REACT_APP_DATA_PROVIDER_URL ? process.env.REACT_APP_DATA_PROVIDER_URL : 'http://localhost:5164'

  try {
    const connection = new HubConnectionBuilder()
    .withUrl(`${apiUrl}/FreeBill/${hubName}`)
    .configureLogging(LogLevel.Debug)
    .withAutomaticReconnect()
    .build()
    await connection.start()
    return connection
  } catch (error) {
    console.log(error)
  }
}

export default connectToHub
